export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00450.9e67ab7e.png";